import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import React from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
// import DashboardTables from "./components/dashboard/DashboardTables";
import LatestJobs from "./components/tables/LatestJobs";
import AdmitCards from "./components/tables/AdmitCards";
import Results from "./components/tables/Results";
import AllJobs from "./components/pages/AllJobs";
import AllAdmitCards from "./components/pages/AllAdmitCards";
import AllResults from "./components/pages/AllResults";
import JobDetails from "./components/pages/JobDetails";
import FAQContent from "./components/site-content/FAQContent";
// import TopJobsCard from "./components/pages/TopJobsCard";
// import { BiColor } from "react-icons/bi";



const SitemapRedirect = () => {
  // Redirect the request to the backend sitemap URL
  window.location.href = "http://localhost:5000/api/sitemap.xml";
  return null;
};


const MainWrapper = () => {
  const location = useLocation();

  const isAllJobsPage = location.pathname === "/all-jobs";

  return (
    <div className="page-wrapper">
  <Header />
  <main className={isAllJobsPage ? "main-all-jobs" : "main-default"}>
    <Routes>
      <Route
        path="/"
        element={
          <>
            <h2>Welcome to IndianJobs360</h2>
            <p>Get Online Form, Results, Admit Card, Answer Key, Syllabus, Career News etc.</p>

            {/* this show the top jobs in boxes based on tag */}
            {/* <TopJobsCard /> */}
            <div className="table-row-desktop">
              <LatestJobs />
              <AdmitCards />
              <Results />
            </div>
            <FAQContent />
          </>
        }
      />
      <Route path="/all-jobs" element={<AllJobs />} />
      <Route path="/all-admit-cards" element={<AllAdmitCards />} />
      <Route path="/all-results" element={<AllResults />} />
      {/* <Route path="/job/:id" element={<JobDetails />} /> */}
      <Route path="/job/:slug" element={<JobDetails />} />
      

    </Routes>
  </main>
  <Footer />
</div>

  );
};

function App() {
  return (
    <Router>
      <div className="page-wrapper">
        <MainWrapper />
      </div>
    </Router>
  );
}

export default App;













